module.exports = __webpack_public_path__ + "img/copaamerica.1f627e4d.jpg";